import Joi from "joi";
import { ChannelOrderPayload } from "../../types";

const maxViews = Number(process.env.REACT_APP_POST_ORDER_MAX_VIEW);

export const getAddChannelOrderShema = () =>
  Joi.object<ChannelOrderPayload>({
    channel: Joi.string().required().trim(),
    speed: Joi.number().required().min(1).max(1000),
    views: Joi.number().required().min(1).max(maxViews),
    random: Joi.number().min(0).max(80),
    type: Joi.string().required().trim(),
    // views_mode: Joi.string().required().trim(),
  }).unknown(true);

export const getEditChannelOrderShema = () =>
  Joi.object<ChannelOrderPayload>({
    speed: Joi.number().required().min(1).max(1000),
    posts_count: Joi.number().min(1),
    views: Joi.number().required().min(1).max(maxViews),
    random: Joi.number().min(0).max(80),
  }).unknown(true);
